
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 36.63 33.685","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.303 7.395a3.08 3.08 0 01-3.075-3.078 3.078 3.078 0 013.075-3.074 3.08 3.08 0 013.077 3.074 3.08 3.08 0 01-3.077 3.078m0-7.397a4.324 4.324 0 00-4.32 4.32 4.326 4.326 0 004.32 4.322 4.328 4.328 0 004.323-4.323c0-2.382-1.94-4.32-4.323-4.32","fill":"#394c71"}}),_c('path',{attrs:{"d":"M15.622 9.822c-1.627 0-5.545 4.303-8.806 7.433L1.08 21.149c-1.149.782.073 2.735 1.006 2.308l6.27-3.073 4.966-3.912v8.767L4.53 24.066c-2.68 0-3.829 3.912-1.15 5.476l5.357.783c0 1.173.377 2.738 1.908 2.738l7.656-1.174 7.656 1.174c1.53 0 1.908-1.565 1.908-2.738l5.357-.783c2.679-1.564 1.53-5.476-1.15-5.476l-8.793 1.173v-8.767l4.965 3.912 6.225 3.05c.979.566 2.26-1.57 1.052-2.285l-5.736-3.894c-3.261-3.13-7.18-7.433-8.806-7.433 0 0-.844.809-2.732.809-1.617 0-2.619-.808-2.619-.808z","fill":"none","stroke":"#394c71","stroke-miterlimit":"10","stroke-width":"1.24425506"}})])
          )
        }
      }
    